/* The logo: public/logo.png (a PNG, ideally light or transparent so it shows on the black header). Replace that file to change it everywhere:
 * the top bar of the app and the header band of the PDF and Excel downloads. If the file cannot be read the downloads are simply made without it. */
export const LOGO_URL = `${process.env.PUBLIC_URL || ''}/logo.png`;

const toBase64 = (bytes) => {
  let s = '';
  for (let i = 0; i < bytes.length; i += 0x8000) s += String.fromCharCode.apply(null, bytes.subarray(i, i + 0x8000));
  return btoa(s);
};

/** PNG bytes -> { base64, dataUrl, w, h } (size read from the PNG header), or null if it is not a PNG. */
export function logoFromBytes(bytes) {
  const sig = [0x89, 0x50, 0x4e, 0x47];
  if (!bytes || bytes.length < 24 || sig.some((b, i) => bytes[i] !== b)) return null;
  const v = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
  const w = v.getUint32(16), h = v.getUint32(20);
  if (!w || !h) return null;
  const base64 = toBase64(bytes);
  return { base64, dataUrl: `data:image/png;base64,${base64}`, w, h };
}

let cached;
/** Fetches the logo once. Resolves to null (never rejects) when there is none. */
export function loadLogo() {
  if (!cached) {
    cached = (async () => {
      try {
        const res = await fetch(LOGO_URL);
        if (!res.ok) return null;
        return logoFromBytes(new Uint8Array(await res.arrayBuffer()));
      } catch { return null; }
    })().then((l) => { if (!l) cached = undefined; return l; });   // try again next time if it failed
  }
  return cached;
}
